import React from 'react'
import { Form, Input } from 'antd'
import { SafetyCertificateOutlined } from '@ant-design/icons'


export default function CaptchaImg(props) {
    const { handleClick, captcha, captchaImg } = props
    const codeValidate = (rule,value,callback)=> {
        if(!value){
            callback("请输入验证码");
            return;
        }
        let v1 = value.toUpperCase();
        let v2 = captcha.toUpperCase();
        console.log(value)
       if(v1 !== v2) {
            callback("验证码有误");
        }else{
            callback();
        }

    }
    return (
        <div id='imageCode'>
            <Form.Item name="imageCode" hasFeedback={true}
                rules={[{required: true, validator:(rule,value,callback)=>codeValidate(rule,value,callback),},]}>
                <Input maxLength={6} prefix={<SafetyCertificateOutlined className="site-form-item-icon" />} placeholder="验证码" />
            </Form.Item>
            <div onClick={handleClick}>
                <img src={captchaImg} alt="点击刷新验证码" />
            </div>
        </div>
    )
}
